import { DateType } from "@date-io/type";
import {
    Gender,
    IBooking,
    ICarGroup,
    ILegalEntity,
    ILocation,
    IMobilePrefix,
    InvoiceType,
    RentalType,
    VehicleType
} from "../../types";

export enum InsertBookingStep {
    AVAILABILITY_PRICE,
    CUSTOMER_DETAILS
}

export enum Country {
    IT = "IT",
    FR = "FR"
}

export enum InsertBookingStateAction {
    DraftEdit = 'DRAFT_EDIT',
    Copy = 'COPY',
    CopyWithRatePlan = "COPY_WITH_RATE_PLAN",
}

export interface AccordionsExpanded {
    extraServices: boolean,
    total: boolean,
    bookingOwner: boolean,
    invoice: boolean,
    firstDriver: boolean,
    additionalDrivers: boolean
}

export interface InsertBookinLocationState {
    booking: IBooking,
    action: InsertBookingStateAction
}

/* ******************     Form     ****************** */

export interface IFormValues {
    basicDetails: {
        rentalType: RentalType,
        pickupLocation: ILocation | null,
        dropoffLocation: ILocation | null,
        pickupDate: DateType | null,
        dropoffDate: DateType | null,
        vehicleCategory: VehicleType,
        carGroup: ICarGroup | null,
        lockGroup: boolean,
        mileageIncluded: string | null,
        customerCode?: string,
        cig?: string | null,
        dossierNumber?: string,
        bookingDateTime: DateType | null,
        tenants: string | null,
        dealers: string | null
    },
    extraServices: {
        ancillary: Record<string, boolean | number>,
        discountOverprice: number | null,
        note: string,
        affiliationCode: string,
        flightNumber: string,
        discountType: 'promo' | 'fca' | null,
        codeDescriptionType?: string,
        discountCode?: string,
        fcaBankCardNumber?: string,
        deliveryGoogleSearch?: string,
        deliveryStreetName?: string,
        deliveryStreetNumber?: string,
        deliveryPostalCode?: string,
        deliveryCity?: string,
        deliveryState?: string,
        collectionGoogleSearch?: string,
        collectionStreetName?: string,
        collectionStreetNumber?: string,
        collectionPostalCode?: string,
        collectionCity?: string,
        collectionState?: string,
        checkAffiliated: any,
        checkCoupon: any
    },
    firstDriver: {
        id: string,
        name: string,
        surname: string,
        birthDate: DateType | null,
        birthNation: string,
        birthPlace: string,
        residenceCountry: string,
        fiscalCode: string,
        drivingLicenseNumber: string,
        email: string,
        mobile: string,
        uuid: string,
        mobilePrefix: IMobilePrefix | null,
        gender: Gender | ''
    },
    invoice: {
        id: string,
        type: InvoiceType | '',
        name: string,
        surname: string,
        birthDate: DateType | null,
        birthNation: string,
        birthPlace: string,
        residenceCountry: string,
        fiscalCode: string,
        drivingLicenseNumber: string,
        email: string,
        mobile: string,
        billingCountry: string | null,
        billingCity: string,
        billingStreetName: string,
        billingStreetNameGoogleSearch?: string,
        billingStreetNumber: string,
        billingPostalCode: string,
        certifiedEmail: string,
        vatNumber: string,
        vatNumberCountry: string,
        siren: string,
        siret: string,
        invoiceCode: string,
        companyName: string,
        uuid: string,
        mobilePrefix: IMobilePrefix | null,
        billingProvince: string | null,
        linkedToBusinessAgreement: boolean,
        legalEntity: ILegalEntity | null,
        publicAuthority: boolean,
        paIdNumber: string
    },
    bookingOwner: {
        id: string,
        name: string,
        surname: string,
        birthDate: DateType | null,
        birthNation: string,
        birthPlace: string,
        residenceCountry: string,
        fiscalCode: string,
        drivingLicenseNumber: string
        email: string,
        mobile: string,
        companyName: string,
        country: string,
        city: string,
        streetName: string,
        streetNumber: string,
        postalCode: string
        certifiedEmail: string,
        telephone: string,
        invoiceCode: string,
        vatNumber: string,
        vatNumberCountry: string,
        mobilePrefix: IMobilePrefix | null,
        uuid: string,
        linkedToBusinessAgreement: boolean,
        legalEntity: ILegalEntity | null,
        publicAuthority: boolean,
        paIdNumber: string,
        siren: string,
        siret: string
    },
    additionalDrivers: {
        id: string,
        name: string,
        surname: string,
        email: string
    }[],
    forceBookingOwner: boolean
}

/* ******************     Table Availabilities     ****************** */

export interface IOneWay {
    location: string,
    date: string,
    product: string
}

export interface IStopSell {
    code: string,
    ruleName: string
}

export interface IDailyAvailability {
    cars: number,
    oneWayInS: IOneWay[],
    stopSells: IStopSell | null
}

export interface ITableAvailabilitiesRow {
    code: string,
    label: string,
    [key: string]: string | IDailyAvailability
}

export interface ITableAvailabilitiesFilter {
    onlyAvailable: boolean
}

export interface IBillingCountryPropsComponent {
    billingCountryDisabled: boolean;
}

export interface IBillingProvincePropsComponent {
    billingProvinceDisabled: boolean;
}
